import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment as env } from "../../../environments/environment";
import { Observable } from "rxjs";
import { HttpService } from "../../shared/services/http.service";
import { SortType } from "../../shared/models";
import {
  MAGMA_API_BASE,
  API_CUSTOMERS,
  API_CUSTOMERS_EXPORT,
  API_CHECK_COUPON,
  API_COUPONS,
  API_COUPONS_EXPORT,
  API_ADMIN_PRODUCTS,
  API_ADMIN_COLLECTIONS,
  API_ADMIN_ROLES,
  API_ADMIN_SUBSCRIPTIONS_IMPORT_CSV,
  API_ADMIN_USERS,
  API_UPDATE_PASSWORD
} from "../../shared/constants/constants";

@Injectable({
  providedIn: "root",
})
export class CollectionService {
  private HTTPheaders;
  private optionsResponseTypeBlob;

  constructor(private http: HttpClient, private httpService: HttpService) {
    this.HTTPheaders = {
      "Content-Type": "application/json",
      "language-locale": (env.staging || env.production) ? "ru" : "it"
    };
    this.optionsResponseTypeBlob = {
      responseType: "blob" as "json",
    };
  }
  getCollections(
    params: { [key: string]: any }
  ): Observable<any> {

    let httpParams = new HttpParams();

    // Aggiunge tutti i parametri (inclusi paginazione, filtri e sorting)
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value !== null && value !== undefined && value !== '') {
        httpParams = httpParams.set(key, value.toString());
      }
    });
    const url = env.baseUrl + `${MAGMA_API_BASE}${API_CUSTOMERS}`;
    return this.http.get<any>(url, {
      params: httpParams,
      ...this.httpService.getOptions(this.HTTPheaders)
    });
  }

  addNewCustomer(data: any): Observable<any> {
    return this.http.post<any>(env.baseUrl + `${MAGMA_API_BASE}${API_CUSTOMERS}`, data);
  }

  getProducts(): Observable<any> {
    return this.http.get<any>(env.baseUrl + API_ADMIN_PRODUCTS, this.httpService.getOptions(this.HTTPheaders));
  }

  getUserDetail(customer: string): Observable<any> {
    return this.http.get<any>(env.baseUrl + `${MAGMA_API_BASE}${API_CUSTOMERS}/${customer}`, this.httpService.getOptions(this.HTTPheaders));
  }

  checkCoupon(coupon: string): Observable<any> {
    return this.http.get<any>(env.baseUrl + `${MAGMA_API_BASE}${API_CHECK_COUPON}?code=${coupon}`,
      {
        headers: this.HTTPheaders
      });
  }

  activateCoupon(body: any): Observable<any> {
    return this.http.put<any>(env.baseUrl + `${MAGMA_API_BASE}${API_CUSTOMERS}/${body.id}`, body);
  }

  editCollection(token: string, body: any) {
    return this.http.put<any>(
      env.baseUrl + `${API_ADMIN_COLLECTIONS}/${token}`,
      body,
      this.httpService.getOptions(this.HTTPheaders)
    );
  }

  getRole(): Observable<any> {
    return this.http.get<any>(env.baseUrl + API_ADMIN_ROLES, this.httpService.getOptions(this.HTTPheaders));
  }

  sendCsv(payload: FormData): Observable<any> {
    const headers = new HttpHeaders({
      "language-locale": (env.staging || env.production) ? "ru" : "it",
    });
    return this.http.post<any>(
      env.baseUrl + API_ADMIN_SUBSCRIPTIONS_IMPORT_CSV,
      payload,
      { headers }
    );
  }

  getUtenteById(id: number): Observable<any> {
    return this.http.get<any>(env.baseUrl + `${API_ADMIN_USERS}/${id}`);
  }

  createUtente(utente: any): Observable<any> {
    return this.http.post<any>(env.baseUrl + API_ADMIN_USERS, utente);
  }

  updateUtente(id: number, utente: any): Observable<any> {
    return this.http.put<any>(env.baseUrl + `${API_ADMIN_USERS}/${id}`, utente);
  }

  resetPswUser(payload: any): Observable<any> {
    return this.http.post<any>(
      env.baseUrl + API_UPDATE_PASSWORD, payload
    );
  }

  deleteUser(id: number): Observable<any> {
    return this.http.delete<any>(env.baseUrl + `${API_ADMIN_USERS}/${id}`);
  }

  getExport(token: string, format = 'xlsx') {
    return this.http.get<any>(env.baseUrl + `${MAGMA_API_BASE}${API_CUSTOMERS_EXPORT}`, this.optionsResponseTypeBlob);
  }

  /** chiamata che ritorna i coupon attivati con i prodotti */
  getCollectionsReport(
    params: { [key: string]: any }
  ): Observable<any> {

    let httpParams = new HttpParams();

    // Aggiunge tutti i parametri (inclusi paginazione, filtri e sorting)
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value !== null && value !== undefined && value !== '') {
        httpParams = httpParams.set(key, value.toString());
      }
    });
    const url = env.baseUrl + `${MAGMA_API_BASE}${API_COUPONS}`;
    return this.http.get<any>(url, {
      params: httpParams,
      ...this.httpService.getOptions(this.HTTPheaders)
    });
  }

  /** export report coupon su prodotti */
  getExportReport(token: string, format = 'xlsx') {
    return this.http.get<any>(env.baseUrl + `${MAGMA_API_BASE}${API_COUPONS_EXPORT}`, this.optionsResponseTypeBlob);
  }

}
